import * as React from 'react';
import Chart from "react-apexcharts";

import { useTranslation } from "react-i18next";
import ReactECharts from "echarts-for-react";
import { useLocation } from 'react-router-dom';
import { Stack } from '@mui/system';

const CostChart = (props) => {

    const {data, currencySymbol, aggType} = props;

    const { t } = useTranslation();

    let series;
    
    let onlyGrid
    let baseline
    let manual
    let optimized
    let timestamps

    onlyGrid = data?.only_grid?.map((item)=>item.cost);
    baseline = data?.baseline?.map((item)=>item.cost);
    manual = data?.manual?.map((item)=>item.cost);
    optimized = data?.optimized?.map((item)=>item.cost);


    for (let key in data) {
        timestamps = data[key].map(item => item.date)
        continue
    }


    onlyGrid = data?.only_grid?.map((item)=>([ item.date,  item.cost]));
    baseline = data?.baseline?.map((item)=>([ item.date,  item.cost]));
    manual = data?.manual?.map((item)=>([ item.date,  item.cost]));
    optimized = data?.optimized?.map((item)=>([ item.date,  item.cost]));

    
    

    series = [
        {
            name: t("Solar"), 
            data: baseline,
            type: "line",
            showSymbol: false,
        },
        {
            name: t("Grid"),   
            data: onlyGrid,
            type: "line",
            showSymbol: false,
        },
        {
            name: t("Cogeneration (manual)"), 
            data: manual,
            type: "line",
            showSymbol: false,
        },
        {
            name: t("Optimised"), 
            data: optimized,
            type: "line",
            showSymbol: false,
        }
    ]
    
    let options = {
        xAxis: {
            type: 'time',
            axisLabel: {
                rotate: 45,
                interval: 1,
                hideOverlap: true
            },
            splitNumber: 12,
            max: function (value) {
                return new Date(value.max).getTime() + 1000 * 60; 
            }
            
            
		},
        grid: {
            bottom: 60,
            top: 15,
        },
        yAxis: {
			splitArea: {
				show: false,
			},
            axisLabel: {
                formatter: (value) => currencySymbol + value
            },
            min: 0,
            type: 'value'
		},
        legend: {
            show: true,
            bottom: 0, 
			left: "center", 
        },
        tooltip: {
            show: true,
            trigger: 'axis',
            valueFormatter:  (value) => {
                const truncatedValue = typeof value == "number" ? value.toLocaleString(navigator.language,{
                    minimumFractionDigits:2,
                    maximumFractionDigits:2
                }) : value
                const truncatedValueWithCurrency = currencySymbol == '£' ?  currencySymbol + truncatedValue : truncatedValue + currencySymbol
                return truncatedValueWithCurrency
            } 
                
        },
        series,
        textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
        }
    }

    if (aggType=='q') {
        options.xAxis = { type:'category'}
    } else if (aggType == 'y') {
        options.xAxis = {...options.xAxis, splitNumber:2}
    }

    return (
        <Stack height={'100%'}>
            <ReactECharts option={options} style={{ width: '100%', height: '100%' }}/>
        </Stack>
        
        
    )

}

export default CostChart;